/**
 * Interface for form component refs that support validation methods.
 *
 * This interface defines the expected methods available on form component refs,
 * particularly for dynamically loaded form components that support validation.
 */
export type FormRef = {
  /**
   * Validates the current form data and updates the form's validation state.
   * This method triggers form validation without submitting the form.
   */
  validateForm: () => void;
};

export const formRefRegistry = new Map<number, FormRef | null>();
